export default {
  roadmap_title_first: 'InGame 致力于不断升级服务能力，提升使用体验',
  roadmap_title_second: 'RoadMap',
  roadmap_version: '查看InGame版本说明',
};
